import styled from 'styled-components';

const hcBackgroundColor = '#fff';
const hcNeutralColor_100 = '#000';
const hcNeutralColor_80 = '#333';
const hcNeutralColor_60 = '#666';
const hcNeutralColor_40 = '#999';
const hcNeutralColor_20 = '#ccc';
const hcNeutralColor_10 = '#e6e6e6';
const hcNeutralColor_5 = '#f2f2f2';
const hcNeutralColor_3 = '#c5d0db';
const hcHighlightColor_100 = '#039';
const hcHighlightColor_80 = '#335cad';
const hcHighlightColor_60 = '#6685c2';
const hcHighlightColor_20 = '#ccd6eb';
const hcHighlightColor_10 = '#e6ebf5';
const hcTooltipBackground = hcBackgroundColor;
const colorGray = '#747e8a';
const colorBorderRegular = '#c5d0db';

export const ChartWrapper = styled.div`
  .highcharts-container {
    position: relative;
    z-index: 0; /* #1072 */
    overflow: hidden;
    width: 100%;
    height: 100%;
    font-size: 12px;
    line-height: normal;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    text-align: left;
  }

  .highcharts-root {
    display: block;
  }

  .highcharts-root text {
    stroke-width: 0;
  }

  .highcharts-strong {
    font-weight: bold;
  }

  .highcharts-emphasized {
    font-style: italic;
  }

  .highcharts-anchor {
    cursor: pointer;
  }

  .highcharts-background {
    fill: none;
  }

  .highcharts-plot-border,
  .highcharts-plot-background {
    fill: none;
  }

  .highcharts-label-box {
    fill: none;
  }

  .highcharts-button-box {
    fill: inherit;
  }

  .highcharts-tracker-line {
    fill: none;
    stroke: rgba(192, 192, 192, 0.0001);
    stroke-linejoin: round;
    stroke-width: 22;
  }

  .highcharts-tracker-area {
    fill: rgba(192, 192, 192, 0.0001);
    stroke-width: 0;
  }

  /* Titles */

  .highcharts-title {
    fill: ${hcNeutralColor_80};
    font-size: 1.5em;
  }

  .highcharts-subtitle {
    fill: ${hcNeutralColor_60};
  }

  /* Axes */

  .highcharts-axis-line {
    fill: none;
    stroke: ${hcHighlightColor_20};
  }

  .highcharts-yaxis .highcharts-axis-line {
    stroke-width: 0;
  }

  .highcharts-axis-title {
    fill: ${hcNeutralColor_60};
  }

  .highcharts-axis-labels {
    color: ${colorGray};
    cursor: default;
    fill: ${hcNeutralColor_60};
    font-size: 0.9em;
  }

  .highcharts-grid-line {
    fill: none;
    stroke: ${colorBorderRegular};
  }

  .highcharts-xaxis-grid .highcharts-grid-line {
    stroke-width: 0;
  }

  .highcharts-tick {
    width: 100px;
    stroke: ${hcHighlightColor_20};
  }

  .highcharts-yaxis .highcharts-tick {
    stroke-width: 0;
  }

  .highcharts-minor-grid-line {
    stroke: ${hcNeutralColor_5};
  }

  .highcharts-crosshair-thin {
    stroke: ${hcNeutralColor_20};
    stroke-width: 1px;
  }

  .highcharts-crosshair-category {
    stroke: ${colorBorderRegular};
  }

  /* Credits */

  .highcharts-credits {
    cursor: pointer;
    fill: ${hcNeutralColor_40};
    font-size: 0.7em;
    transition: fill 250ms, font-size 250ms;
  }

  .highcharts-credits:hover {
    fill: black;
    font-size: 1em;
  }

  /* Tooltip */

  .highcharts-tooltip {
    cursor: default;
    filter: none !important;

    /* remove shadow */
    font-size: 1.25em;
    pointer-events: none;
    transition: stroke 150ms;
    white-space: nowrap;
  }

  .highcharts-tooltip-container {
    border: 1px solid rgba(0, 36, 77, 0.08);
    background-color: white;
    border-radius: 4px;
  }

  .highcharts-tooltip text {
    fill: ${hcNeutralColor_80};
  }

  .highcharts-tooltip-value {
    text-align: right;

    &--single {
      text-align: left;
    }
  }

  .highcharts-tooltip table {
    border: none;
    margin: 0;
  }

  .highcharts-tooltip table td,
  .highcharts-tooltip table th {
    padding: 0;
    border: none;
    background: transparent;
    font-weight: normal;
  }

  .highcharts-tooltip .highcharts-header {
    color: ${colorGray};
    fill: ${colorGray};
    font-size: 0.917em;
    letter-spacing: 0.4px;
  }

  .highcharts-tooltip-box {
    fill: ${hcTooltipBackground};
    stroke: ${colorBorderRegular};
    stroke-width: 1px;
  }

  .highcharts-tooltip-box .highcharts-label-box {
    fill: ${hcTooltipBackground};
  }

  .highcharts-selection-marker {
    fill: ${hcHighlightColor_80};
    fill-opacity: 0.25;
  }

  .highcharts-graph {
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2px;
  }

  .highcharts-state-hover .highcharts-graph {
    stroke-width: 3;
  }

  .highcharts-state-hover path {
    transition: stroke-width 50; /* quick in */
  }

  .highcharts-state-normal path {
    transition: stroke-width 250ms; /* slow out */
  }

  /* Legend hover affects points and series */

  g.highcharts-series,
  .highcharts-point,
  .highcharts-markers,
  .highcharts-data-labels {
    transition: opacity 250ms;
  }

  .highcharts-series-hover,
  .highcharts-point-hover {
    cursor: pointer;
  }

  .highcharts-legend-series-active g.highcharts-series:not(.highcharts-series-hover),
  .highcharts-legend-point-active .highcharts-point:not(.highcharts-point-hover),
  .highcharts-legend-series-active .highcharts-markers:not(.highcharts-series-hover),
  .highcharts-legend-series-active .highcharts-data-labels:not(.highcharts-series-hover) {
    opacity: 0.2;
  }

  .highcharts-tooltip-gray {
    color: ${colorGray};
  }

  /* Series options */

  /* Default colors */

  .highcharts-color-0 {
    fill: ${(props) => props.theme.colors.brand};
    stroke: ${(props) => props.theme.colors.brand};
  }

  span.highcharts-color-0 {
    color: ${(props) => props.theme.colors.brand};
  }

  .highcharts-color-1 {
    fill: ${(props) => props.theme.colors.action};
    stroke: ${(props) => props.theme.colors.action};
  }

  span.highcharts-color-1 {
    color: ${(props) => props.theme.colors.action};
  }

  .highcharts-color-2 {
    fill: ${(props) => props.theme.colors.info};
    stroke: ${(props) => props.theme.colors.info};
  }

  span.highcharts-color-2 {
    color: ${(props) => props.theme.colors.info};
  }

  .highcharts-color-3 {
    fill: ${(props) => props.theme.colors.warning};
    stroke: ${(props) => props.theme.colors.warning};
  }

  span.highcharts-color-3 {
    color: ${(props) => props.theme.colors.warning};
  }

  .highcharts-color-4 {
    fill: ${(props) => props.theme.colors.danger};
    stroke: ${(props) => props.theme.colors.danger};
  }

  span.highcharts-color-4 {
    color: ${(props) => props.theme.colors.danger};
  }

  .highcharts-color-5 {
    fill: ${colorGray};
    stroke: ${colorGray};
  }

  span.highcharts-color-5 {
    color: ${colorGray};
  }

  .highcharts-color-6 {
    fill: #e4d354;
    stroke: #e4d354;
  }

  .highcharts-color-7 {
    fill: #2b908f;
    stroke: #2b908f;
  }

  .highcharts-color-8 {
    fill: #f45b5b;
    stroke: #f45b5b;
  }

  .highcharts-color-9 {
    fill: #91e8e1;
    stroke: #91e8e1;
  }

  .highcharts-area {
    fill-opacity: 0.75;
    stroke-width: 0;
  }

  .highcharts-markers {
    stroke: ${hcBackgroundColor};
    stroke-width: 1px;
  }

  .highcharts-point {
    stroke-width: 1px;
  }

  .highcharts-dense-data .highcharts-point {
    stroke-width: 0;
  }

  .highcharts-data-label {
    font-size: 0.9em;
    font-weight: bold;
  }

  .highcharts-data-label-box {
    fill: none;
    stroke-width: 0;
  }

  .highcharts-data-label text,
  text.highcharts-data-label {
    fill: ${hcNeutralColor_80};
  }

  .highcharts-data-label-connector {
    fill: none;
  }

  .highcharts-halo {
    fill-opacity: 0.25;
    stroke-width: 0;
  }

  .highcharts-point {
    stroke-width: 0;
  }

  .highcharts-series:not(.highcharts-pie-series) .highcharts-point-select,
  .highcharts-markers .highcharts-point-select {
    fill: ${hcNeutralColor_20};
    stroke: ${hcNeutralColor_100};
  }

  .highcharts-column-series rect.highcharts-point {
    stroke: ${hcBackgroundColor};
  }

  .highcharts-column-series .highcharts-point {
    transition: fill-opacity 250ms;
  }

  .highcharts-column-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }

  .highcharts-pie-series .highcharts-point {
    stroke: ${hcBackgroundColor};
    stroke-linejoin: round;
  }

  .highcharts-pie-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }

  .highcharts-funnel-series .highcharts-point {
    stroke: ${hcBackgroundColor};
    stroke-linejoin: round;
  }

  .highcharts-funnel-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }

  .highcharts-funnel-series .highcharts-point-select {
    fill: inherit;
    stroke: inherit;
  }

  .highcharts-pyramid-series .highcharts-point {
    stroke: ${hcBackgroundColor};
    stroke-linejoin: round;
  }

  .highcharts-pyramid-series .highcharts-point-hover {
    fill-opacity: 0.75;
    transition: fill-opacity 50ms;
  }

  .highcharts-pyramid-series .highcharts-point-select {
    fill: inherit;
    stroke: inherit;
  }

  .highcharts-solidgauge-series .highcharts-point {
    stroke-width: 0;
  }

  .highcharts-treemap-series .highcharts-point {
    stroke: ${hcNeutralColor_10};
    stroke-width: 1px;
    transition: stroke 250ms, fill 250ms, fill-opacity 250ms;
  }

  .highcharts-treemap-series .highcharts-point-hover {
    stroke: ${hcNeutralColor_40};
    transition: stroke 25ms, fill 25ms, fill-opacity 25ms;
  }

  .highcharts-treemap-series .highcharts-above-level {
    display: none;
  }

  .highcharts-treemap-series .highcharts-internal-node {
    fill: none;
  }

  .highcharts-treemap-series .highcharts-internal-node-interactive {
    cursor: pointer;
    fill-opacity: 0.15;
  }

  .highcharts-treemap-series .highcharts-internal-node-interactive:hover {
    fill-opacity: 0.75;
  }

  /* Legend */

  .highcharts-legend-box {
    fill: none;
    stroke-width: 0;
  }

  /* only for highmaps legend */

  .highcharts-legend-item > rect:not(.highcharts-point) {
    height: 10px;
  }

  .highcharts-legend-item > text {
    cursor: pointer;
    fill: ${hcNeutralColor_80};
    font-size: var(--hc-legend-font-size);
    font-weight: bold;
    stroke-width: 0;
  }

  .highcharts-legend-item:hover text {
    fill: ${hcNeutralColor_100};
  }

  .highcharts-legend-item-hidden * {
    fill: ${hcNeutralColor_20} !important;
    stroke: ${hcNeutralColor_20} !important;
    transition: fill 250ms;
  }

  .highcharts-legend-nav-active {
    cursor: pointer;
    fill: ${hcHighlightColor_100};
  }

  .highcharts-legend-nav-inactive {
    fill: ${hcNeutralColor_20};
  }

  circle.highcharts-legend-nav-active,
  circle.highcharts-legend-nav-inactive {
    /* tracker */
    fill: rgba(192, 192, 192, 0.0001);
  }

  .highcharts-legend-title-box {
    fill: none;
    stroke-width: 0;
  }

  /* Bubble legend */

  .highcharts-bubble-legend-symbol {
    fill-opacity: 0.5;
    stroke-width: 2;
  }

  .highcharts-bubble-legend-connectors {
    stroke-width: 1;
  }

  .highcharts-bubble-legend-labels {
    fill: ${hcNeutralColor_80};
  }

  /* Loading */

  .highcharts-loading {
    position: absolute;
    z-index: 10;
    background-color: ${hcBackgroundColor};
    opacity: 0.5;
    text-align: center;
    transition: opacity 250ms;
  }

  .highcharts-loading-hidden {
    overflow: hidden;
    height: 0 !important;
    opacity: 0;
    transition: opacity 250ms, height 250ms step-end;
  }

  .highcharts-loading-inner {
    position: relative;
    top: 45%;
    font-weight: bold;
  }

  /* Plot bands and polar pane backgrounds */

  .highcharts-plot-band,
  .highcharts-pane {
    fill: ${hcNeutralColor_100};
    fill-opacity: 0.05;
  }

  .highcharts-plot-line {
    fill: none;
    stroke: ${hcNeutralColor_40};
    stroke-width: 1px;
  }

  /* Highcharts More and modules */

  .highcharts-boxplot-box {
    fill: ${hcBackgroundColor};
  }

  .highcharts-boxplot-median {
    stroke-width: 2px;
  }

  .highcharts-bubble-series .highcharts-point {
    fill-opacity: 0.5;
  }

  .highcharts-errorbar-series .highcharts-point {
    stroke: ${hcNeutralColor_100};
  }

  .highcharts-gauge-series .highcharts-data-label-box {
    stroke: ${hcNeutralColor_20};
    stroke-width: 1px;
  }

  .highcharts-gauge-series .highcharts-dial {
    fill: ${hcNeutralColor_100};
    stroke-width: 0;
  }

  .highcharts-polygon-series .highcharts-graph {
    fill: inherit;
    stroke-width: 0;
  }

  .highcharts-waterfall-series .highcharts-graph {
    stroke: ${hcNeutralColor_80};
    stroke-dasharray: 1, 3;
  }

  .highcharts-sankey-series .highcharts-point {
    stroke-width: 0;
  }

  .highcharts-sankey-series .highcharts-link {
    fill-opacity: 0.5;
    transition: fill 250ms, fill-opacity 250ms;
  }

  .highcharts-sankey-series .highcharts-point-hover.highcharts-link {
    fill-opacity: 1;
    transition: fill 50ms, fill-opacity 50ms;
  }

  .highcharts-venn-series .highcharts-point {
    fill-opacity: 0.75;
    stroke: ${hcNeutralColor_20};
    transition: stroke 250ms, fill-opacity 250ms;
  }

  .highcharts-venn-series .highcharts-point-hover {
    fill-opacity: 1;
    stroke: ${hcNeutralColor_20};
  }

  /* Highstock */

  .highcharts-navigator-mask-outside {
    fill-opacity: 0;
  }

  .highcharts-navigator-mask-inside {
    cursor: ew-resize;
    fill: ${hcHighlightColor_60}; /* navigator.maskFill option */
    fill-opacity: 0.25;
  }

  .highcharts-navigator-outline {
    fill: none;
    stroke: ${hcNeutralColor_20};
  }

  .highcharts-navigator-handle {
    cursor: ew-resize;
    fill: ${hcNeutralColor_5};
    stroke: ${hcNeutralColor_20};
  }

  .highcharts-navigator-series {
    fill: ${hcNeutralColor_80};
    stroke: ${hcNeutralColor_80};
  }

  .highcharts-navigator-series .highcharts-graph {
    stroke-width: 1px;
  }

  .highcharts-navigator-series .highcharts-area {
    fill-opacity: 0.05;
  }

  .highcharts-navigator-xaxis .highcharts-axis-line {
    stroke-width: 0;
  }

  .highcharts-navigator-xaxis .highcharts-grid-line {
    stroke: ${hcNeutralColor_10};
    stroke-width: 1px;
  }

  .highcharts-navigator-xaxis.highcharts-axis-labels {
    fill: ${hcNeutralColor_40};
  }

  .highcharts-xaxis-labels .highcharts-strong {
    fill: ${(props) => props.theme.colors.text};
  }

  .highcharts-column-series {
    fill-opacity: 0.8 !important;

    & .highcharts-point-hover {
      fill-opacity: 0.8 !important;
    }
  }

  .highcharts-navigator-yaxis .highcharts-grid-line {
    stroke-width: 0;
  }

  .highcharts-scrollbar-thumb {
    fill: ${hcNeutralColor_20};
    stroke: ${hcNeutralColor_20};
    stroke-width: 1px;
  }

  .highcharts-scrollbar-button {
    fill: ${hcNeutralColor_10};
    stroke: ${hcNeutralColor_20};
    stroke-width: 1px;
  }

  .highcharts-scrollbar-arrow {
    fill: ${hcNeutralColor_60};
  }

  .highcharts-scrollbar-rifles {
    stroke: ${hcNeutralColor_60};
    stroke-width: 1px;
  }

  .highcharts-scrollbar-track {
    fill: ${hcNeutralColor_5};
    stroke: ${hcNeutralColor_5};
    stroke-width: 1px;
  }

  .highcharts-button {
    cursor: default;
    fill: ${hcNeutralColor_3};
    stroke: ${hcNeutralColor_20};
    stroke-width: 1px;
    transition: fill 250ms;
  }

  .highcharts-button text {
    fill: ${hcNeutralColor_80};
  }

  .highcharts-button-hover {
    fill: ${hcHighlightColor_10};
    stroke: ${hcNeutralColor_20};
    transition: fill 0ms;
  }

  .highcharts-button-hover text {
    fill: ${hcNeutralColor_80};
  }

  .highcharts-button-pressed {
    fill: ${hcHighlightColor_10};
    font-weight: bold;
    stroke: ${hcNeutralColor_20};
  }

  .highcharts-button-pressed text {
    fill: ${hcNeutralColor_80};
    font-weight: bold;
  }

  .highcharts-button-disabled text {
    fill: ${hcNeutralColor_80};
  }

  .highcharts-range-selector-buttons .highcharts-button {
    stroke-width: 0;
  }

  .highcharts-range-label rect {
    fill: none;
  }

  .highcharts-range-label text {
    fill: ${hcNeutralColor_60};
  }

  .highcharts-range-input rect {
    fill: none;
  }

  .highcharts-range-input text {
    fill: ${hcNeutralColor_80};
  }

  .highcharts-range-input {
    stroke: ${hcNeutralColor_20};
    stroke-width: 1px;
  }

  input.highcharts-range-selector {
    position: absolute;
    left: -9em; /* #4798 */
    width: 1px; /* Chrome needs a pixel to see it */
    height: 1px;
    padding: 0;
    border: 0;
    text-align: center;
  }

  .highcharts-crosshair-label text {
    fill: ${hcBackgroundColor};
    font-size: 1.1em;
  }

  .highcharts-crosshair-label .highcharts-label-box {
    fill: inherit;
  }

  .highcharts-candlestick-series .highcharts-point {
    stroke: ${hcNeutralColor_100};
    stroke-width: 1px;
  }

  .highcharts-candlestick-series .highcharts-point-up {
    fill: ${hcBackgroundColor};
  }

  .highcharts-ohlc-series .highcharts-point-hover {
    stroke-width: 3px;
  }

  .highcharts-flags-series .highcharts-point .highcharts-label-box {
    fill: ${hcBackgroundColor};
    stroke: ${hcNeutralColor_40};
    transition: fill 250ms;
  }

  .highcharts-flags-series .highcharts-point-hover .highcharts-label-box {
    fill: ${hcHighlightColor_20};
    stroke: ${hcNeutralColor_100};
  }

  .highcharts-flags-series .highcharts-point text {
    fill: ${hcNeutralColor_100};
    font-size: 0.9em;
    font-weight: bold;
  }

  /* Highmaps */

  .highcharts-coloraxis-grid {
    transform: scale(1, 0.82) translate(0, 2px);

    & .highcharts-grid-line {
      stroke: ${hcBackgroundColor};
    }
  }

  .highcharts-map-series .highcharts-point {
    fill-opacity: 0.8;
    stroke: #fff;
    stroke-width: 0;
    transition: fill 500ms, fill-opacity 500ms, stroke-width 250ms;
  }

  .highcharts-map-series .highcharts-point-hover {
    fill-opacity: 1;
    transition: fill 0ms, fill-opacity 0ms;
  }

  .highcharts-mapline-series .highcharts-point {
    fill: none;
  }

  .highcharts-heatmap-series .highcharts-point {
    stroke-width: 0;
  }

  .highcharts-map-navigation {
    font-size: 1.3em;
    font-weight: bold;
    text-align: center;
  }

  .highcharts-coloraxis {
    stroke-width: 0;
  }

  .highcharts-coloraxis-labels {
    transform: translate(0, -3px);
  }

  .highcharts-coloraxis-marker {
    fill: ${hcNeutralColor_40};
  }

  .highcharts-null-point {
    fill: ${hcNeutralColor_3} !important;
  }

  /* 3d charts */

  .highcharts-3d-frame {
    fill: transparent;
  }

  /* Exporting module */

  .highcharts-contextbutton {
    fill: ${hcBackgroundColor}; /* needed to capture hover */
    stroke: none;
    stroke-linecap: round;
  }

  .highcharts-contextbutton:hover {
    fill: ${hcNeutralColor_10};
    stroke: ${hcNeutralColor_10};
  }

  .highcharts-button-symbol {
    stroke: ${hcNeutralColor_60};
    stroke-width: 3px;
  }

  .highcharts-menu {
    padding: 5px 0;
    border: 1px solid ${hcNeutralColor_40};
    background: ${hcBackgroundColor};
    box-shadow: 3px 3px 10px #888;
  }

  .highcharts-menu-item {
    padding: 0.5em 1em;
    background: none;
    color: ${hcNeutralColor_80};
    cursor: pointer;
    transition: background 250ms, color 250ms;
  }

  .highcharts-menu-item:hover {
    background: ${hcHighlightColor_80};
    color: ${hcBackgroundColor};
  }

  /* Drilldown module */

  .highcharts-drilldown-point {
    cursor: pointer;
  }

  .highcharts-drilldown-data-label text,
  text.highcharts-drilldown-data-label,
  .highcharts-drilldown-axis-label {
    cursor: pointer;
    fill: ${hcHighlightColor_100};
    font-weight: bold;
    text-decoration: underline;
  }

  /* No-data module */

  .highcharts-no-data text {
    fill: ${hcNeutralColor_60};
    font-size: 12px;
    font-weight: bold;
  }

  /* Drag-panes module */

  .highcharts-axis-resizer {
    cursor: ns-resize;
    stroke: black;
    stroke-width: 2px;
  }

  /* Bullet type series */

  .highcharts-bullet-target {
    stroke-width: 0;
  }

  /* Lineargauge type series */

  .highcharts-lineargauge-target {
    stroke: ${hcNeutralColor_80};
    stroke-width: 1px;
  }

  .highcharts-lineargauge-target-line {
    stroke: ${hcNeutralColor_80};
    stroke-width: 1px;
  }

  /* Annotations module */

  .highcharts-annotation-label-box {
    fill: ${hcNeutralColor_100};
    fill-opacity: 0.75;
    stroke: ${hcNeutralColor_100};
    stroke-width: 1px;
  }

  .highcharts-annotation-label text {
    fill: ${hcNeutralColor_10};
  }

  /* Gantt */

  .highcharts-treegrid-node-collapsed,
  .highcharts-treegrid-node-expanded {
    cursor: pointer;
  }

  .highcharts-point-connecting-path {
    fill: none;
  }

  .highcharts-grid-axis .highcharts-tick {
    stroke-width: 1px;
  }

  .highcharts-grid-axis .highcharts-axis-line {
    stroke-width: 1px;
  }
`;
